// @flow
import { withRouter } from 'react-router-dom'

export default function withRouterWrapper(...args: any): any {
  return withRouter(...args)
}
